import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  margin: 80px auto 0;
  width: 526px !important;
  position: relative;
  text-align: left;

  ul {
    display: inline-block;
  }

  li {
    width: 370px;
    height: 50px;
    margin: 0 auto 18px;
    text-align: left;
    position: relative;
    background-color: #f6f3f2;
  }

  li img {
    position: absolute;
    top: 14px;
    left: 15px;
  }
`;

const LoginInputWrapDiv = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>;
};

export default LoginInputWrapDiv;
